import { Injectable, inject } from '@angular/core';

import { LocalStoreService, NativeAppService, SessionStoreService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class StoragePersister {
    private session = inject(SessionStoreService);
    private local = inject(LocalStoreService);
    private nativeAppService = inject(NativeAppService);

    private readonly STORE_KEY = 'redux-store-v3';

    /**
     * Apply the new saved state over the current saved and save it.
     * This will allow features to save state individually.
     *
     * @param state update on state
     */
    save(state: object): void {
        if (!this.nativeAppService.isTerminal) {
            this.local.set(this.STORE_KEY, state);

            return;
        }
        this.session.set(this.STORE_KEY, state);
    }

    load(): object | undefined {
        const savedState = !this.nativeAppService.isTerminal ? this.local.get(this.STORE_KEY) : this.session.get(this.STORE_KEY);

        return savedState ? savedState : undefined;
    }
}
